import { useEffect, useState } from 'react';
import { formatAge } from '@/lib/utils';

export function useBabyAge(dateOfBirth: string | null | undefined): string {
  const [label, setLabel] = useState(() =>
    dateOfBirth ? formatAge(dateOfBirth) : ''
  );

  useEffect(() => {
    if (!dateOfBirth) {
      setLabel('');
      return;
    }
    setLabel(formatAge(dateOfBirth));
    const interval = setInterval(() => setLabel(formatAge(dateOfBirth)), 60_000);
    return () => clearInterval(interval);
  }, [dateOfBirth]);

  return label;
}
